import React, { useState } from "react";
import Track from "../Track/Track";
import "./DisplayCup.css";

export default function DisplayCupBrowse(props) {
    const w = props.width;
    const [name, setName] = useState("");

    return <div>
        { props.editName && <input className="cupNameInput"
                placeholder="Name your custom cup"
                value={name}
                onChange={(e) => {
                    setName(e.target.value);
                    props.editedName(e.target.value);
                }}
            />
        }
        <ul className="tracks-background tracks-browse">
            {
                props.tracks &&
                props.tracks.map((element, index) => {
                    //console.log(element);
                    return <Track
                        key={index}
                        index={index}
                        track={element}
                        showCursor={props.showCursor}
                        size={w <= 1100 || props.page === "browse" ? "medium" : "big"}
                        tabIndex={-1}
                        selectTrack={5}
                        showEmblem={true}
                    />
                })
            }
        </ul>
    </div>
}